/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portal_Scanner_SubtitleInputs */

const en_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const de_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const fr_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const es_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const it_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const nl_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const pl_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const fi_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const da_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

const sv_portal_scanner_subtitle = /** @type {(inputs: Portal_Scanner_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discover jobs from ${i?.count} company career pages.`)
};

/**
* | output |
* | --- |
* | "Discover jobs from {count} company career pages." |
*
* @param {Portal_Scanner_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_subtitle = /** @type {((inputs: Portal_Scanner_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_subtitle(inputs)
	if (locale === "fr") return fr_portal_scanner_subtitle(inputs)
	if (locale === "es") return es_portal_scanner_subtitle(inputs)
	if (locale === "it") return it_portal_scanner_subtitle(inputs)
	if (locale === "nl") return nl_portal_scanner_subtitle(inputs)
	if (locale === "pl") return pl_portal_scanner_subtitle(inputs)
	if (locale === "fi") return fi_portal_scanner_subtitle(inputs)
	if (locale === "da") return da_portal_scanner_subtitle(inputs)
	if (locale === "sv") return sv_portal_scanner_subtitle(inputs)
	return en_portal_scanner_subtitle(inputs)
});